import AuthService from './auth.service'

let Auth = new AuthService();

export {
  Auth
}
